import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../../util/withRouter';
import { FormattedMessage } from 'react-intl';
import { Link, NavLink } from 'react-router-dom';
import windowSize from '../../../../util/windowSize';
import { Button, Navbar, Nav, Container, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toggleNavigationShown, toggleNavigationMenuOpened, toggleNavigationExpanded } from '../../AppActions';
import { trackMenuScrollCheck } from '../../../../util/mixpanel';

const menuScrollSent = { menu_scrolled: false, menu_not_scrolled: false };

// Import Style
import './Navigation.scss';

import logo from '../../../../assets/img/nave-logo-white.svg';
import _ from 'lodash';

export class Navigation extends Component {
  static defaultProps = {
    showLinks: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  handleHover(){
    if (this.state.isLocked) return
    this.setState(prevState => ({
      isLocked: prevState.isHovered,
      isHovered: !prevState.isHovered
    }), () => setTimeout(() => this.setState({ isLocked: false }), 100));
  }



  isActive(path, search) {
    return this.props && this.props.location && this.props.location.search === search
    && (this.props.location.pathname === path || this.props.location.pathname === path + '/');
  }

  componentDidMount() {
    const navigation = window && window.localStorage && window.localStorage.getItem('navigation');
    if (navigation) {
      let value;
      try {
        value = JSON.parse(navigation);
      } catch (err) {}
      if (value) {
        this.props.toggleNavigationShown(value.navigationShown || false);
        this.props.toggleNavigationMenuOpened(value.navigationMenuOpened || false);
        this.props.toggleNavigationExpanded(value.navigationExpanded || ['flow-metrics', 'executive']);
      }
    } else {
      this.props.toggleNavigationShown(false);
      this.props.toggleNavigationMenuOpened(false);
      this.props.toggleNavigationExpanded(['flow-metrics', 'executive']);
    }

    this.menuScrollHandler = (e) => {
      try {
        const menu = document.querySelector('.navigation-inner .navbar-nav');
        if (menuScrollSent.menu_scrolled && menuScrollSent.menu_not_scrolled) return;
        if (!menu || !menu.contains(e.target) || e.deltaY === 0) return;
        if (menu.scrollHeight <= menu.clientHeight) return;

        const startTop = menu.scrollTop;
        const info = {
          delta_x: e.deltaX,
          delta_y: e.deltaY,
          delta_mode: e.deltaMode,
          default_prevented: e.defaultPrevented,
          target: e.target.tagName.toLowerCase() + '.' + Array.from(e.target.classList).join('.'),
          menu_state: this.props.navigationMenuOpened ? 'wide' : 'narrow',
          window_inner_width: window.innerWidth,
          window_inner_height: window.innerHeight,
          device_pixel_ratio: window.devicePixelRatio,
          user_agent: navigator.userAgent,
        };

        setTimeout(() => {
          try {
            const outcome = menu.scrollTop === startTop ? 'menu_not_scrolled' : 'menu_scrolled';
            if (menuScrollSent[outcome]) return;
            menuScrollSent[outcome] = true;
            trackMenuScrollCheck({ ...info, outcome });
          } catch (err) {}
        }, 300);
      } catch (err) {}
    };
    document.addEventListener('wheel', this.menuScrollHandler, { passive: true });
  }

  componentWillUnmount() {
    if (this.menuScrollHandler) {
      document.removeEventListener('wheel', this.menuScrollHandler);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      window && window.localStorage && (
        prevProps.navigationExpanded !== this.props.navigationExpanded || 
        prevProps.navigationShown !== this.props.navigationShown ||
        prevProps.navigationMenuOpened !== this.props.navigationMenuOpened
      )
    ) {
      if (window && window.localStorage) {
        window.localStorage.setItem('navigation', JSON.stringify({
          navigationShown: this.props.navigationShown,
          navigationExpanded: this.props.navigationExpanded,
          navigationMenuOpened: this.props.navigationMenuOpened
        }));
      }
    }
  }

  renderChartNavLink = (key, url, imageId, messageId, tooltipId, end = false) => {
    return (
      <Nav.Link key={key} as={NavLink} eventKey={key} to={url} className={({ isActive }) => isActive ? 'active' : ''} end>
        <span className={`images ${imageId}`}></span>
        <FormattedMessage id={messageId} />
        <OverlayTrigger placement="right" 
          overlay={<Tooltip id={tooltipId} className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id={messageId} /></Tooltip>}>
          <span className="tooltip"></span>
        </OverlayTrigger>
      </Nav.Link>
    )
  }

  render() {
    const {
      showLinks,
      dashboard,
      user,
      toggleNavigationShown,
      navigationShown,
      toggleNavigationMenuOpened,
      navigationMenuOpened,
      toggleNavigationExpanded,
      navigationExpanded,
      dashboards,
    } = this.props;
    const dashboardId = dashboard && dashboard._id ? dashboard._id : user.config.selectedDashboard;
    const linksExecutive = [
      this.renderChartNavLink(4, `/report`, 'executive-head', 'exec_rep', 'executive-dashboard'),
      this.renderChartNavLink(5, `/portfolios`, 'exec_rep', 'comp_rep', 'executive-report'),
    ]
    const linksDashboard = [
      this.renderChartNavLink(1, `/dashboard/${dashboardId}/process`, 'process-improvement', 'processImprovement', 'process-improvement'),
      this.renderChartNavLink(2, `/dashboard/${dashboardId}`, 'flow-metric-head', 'flowMetricsAndAnalytics', 'flow-metrics-and-analitics', true),
      this.renderChartNavLink(8, `/dashboard/${dashboardId}/cfd`, 'cfd', 'cfd',  'cumulative-flow-diagram'),
      this.renderChartNavLink(9, `/dashboard/${dashboardId}/ctsp`, 'ctsp', 'ctsp', 'cycle-time-scatterplot'),
      this.renderChartNavLink(10, `/dashboard/${dashboardId}/ctb`, 'ctb', 'ctb', 'cycle-time-breakdown'),
      this.renderChartNavLink(11, `/dashboard/${dashboardId}/cth`, 'cth', 'cth', 'cycle-time-histogram'),
      this.renderChartNavLink(12, `/dashboard/${dashboardId}/cta`, 'cta', 'cta', 'aging-chart'),
      this.renderChartNavLink(13, `/dashboard/${dashboardId}/trc`, 'trc', 'throughput', 'throughput-run'),
      this.renderChartNavLink(14, `/dashboard/${dashboardId}/th`, 'th', 'throughputHistogram', 'throughput-run'),
      this.renderChartNavLink(15, `/dashboard/${dashboardId}/fe`, 'fe', 'flowEfficiency', 'flow-efficiency'),
      this.renderChartNavLink(16, `/dashboard/${dashboardId}/ddp`, 'ddp', 'dueDatePerf', 'due-date-performance'),
      this.renderChartNavLink(17, `/dashboard/${dashboardId}/montecarlodates`, 'mc1', 'monteCarloDate', 'monte-carlo-delivery-date'),
      this.renderChartNavLink(18, `/dashboard/${dashboardId}/montecarlotasks`, 'mc2', 'monteCarloTasks', 'monte-carlo-number-tasks'),
      this.renderChartNavLink(19, `/dashboard/${dashboardId}/forecasts`, 'continues-forecasting', 'continuesForecasting', 'continues-forecasting')
    ];

    return (
      <div className={`navigation ${!navigationMenuOpened ? 'nav-main-close' : 'nav-main-open'} ${!showLinks && 'no-show-link'}`} >
        <div className="navigation-inner">
          <div className='header_logo'>
            { this.props.outside ?(<img src={logo} alt="" />):
            this.props.windowWidth > 992 ? (
              <Link className="logo" to={`${dashboard && dashboard._id ? `/dashboard/${dashboardId}/process` : '/'}`}>
                <img src={logo} alt="" />
              </Link>
            ) : (
              <Button id="hamburger-button" className='btn-hamburger' onClick={() => toggleNavigationShown(!navigationShown)}>
                <span></span>
                <span></span>
                <span></span>
              </Button>
            )}
          </div>
          <Navbar>
            <Container>
            {showLinks &&
              <Nav className='menu'>
                {/* {links} */}
                <Accordion activeKey={navigationExpanded} onSelect={toggleNavigationExpanded} alwaysOpen>
                {user && user.permissions && (user.permissions.manageDashboards || user.permissions.manageDashboardsViewOnly || user.permissions.dashboards && user.permissions.dashboards.length > 0) && dashboards &&(
                  <Accordion.Item eventKey="flow-metrics" className='links-wrap'>
                    <Accordion.Header className="links-wrap-header nav-link">
                      <span className='images flow-metric'></span>
                      <span>Team Dashboards</span>
                      <OverlayTrigger placement="right" 
                        overlay={<Tooltip id="team-dashboards" className='tooltip_dark max-width-200 text-align-left'>Team Dashboards</Tooltip>}>
                        <span className="tooltip"></span>
                      </OverlayTrigger>
                    </Accordion.Header>
                    <Accordion.Body>
                      {linksDashboard}
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                  <Accordion.Item eventKey="executive" className='links-wrap' >
                    <Accordion.Header className="links-wrap-header nav-link">                      
                      <span className='images portfolios_head dark'></span>
                      <span>Portfolio Dashboards</span>
                      <OverlayTrigger placement="right" 
                        overlay={<Tooltip id="executive-view" className='tooltip_dark max-width-200 text-align-left'>Portfolio Dashboards</Tooltip>}>
                        <span className="tooltip"></span>
                      </OverlayTrigger>
                    </Accordion.Header>
                    <Accordion.Body>
                      {linksExecutive}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Nav>
            }
            </Container>
          </Navbar>
        </div>
        <div className="btn-open-menu" >
          <button onClick={() => toggleNavigationMenuOpened(!navigationMenuOpened)}></button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleNavigationShown: show => dispatch(toggleNavigationShown(show)),
    toggleNavigationExpanded: expanded => dispatch(toggleNavigationExpanded(expanded)),
    toggleNavigationMenuOpened: opened => dispatch(toggleNavigationMenuOpened(opened)),
  };
};

function mapStateToProps(state) {
  const dashboards = state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards;
  return {
    app: state.app.app,
    navigationShown: state.app.navigationShown,
    navigationExpanded: state.app.navigationExpanded,
    navigationMenuOpened: state.app.navigationMenuOpened,
    dashboard: state.dashboards.selected,    
    outside: state.app.outside,
    user: state.auth.user,
    dashboards,
  };
}

export default windowSize(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps, null, {
      pure: false
    })(Navigation)
  )
);
